import { connect } from 'react-redux'
import SelectWithPolygonLayer from './SelectWithPolygonLayer';
import { selectWithPolygon } from '../../actionCreators';

const mapStateToProps = (state, ownProps) => ({
	active: state.selectWithPolygon
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	onComplete: (polygon) => dispatch(selectWithPolygon(polygon))
})

export default connect(mapStateToProps, mapDispatchToProps)(SelectWithPolygonLayer);


// WEBPACK FOOTER //
// ./src/components/Map/SelectWithPolygonLayerContainer.js